import React from 'react'
import DatePicker from 'react-datepicker'
import '../../../../styles/assets/date-picker.css';
//import 'react-datepicker/dist/react-datepicker.css';
// import moment from 'moment'

import './style.scss'

export default class DateInput extends React.Component{

    constructor(props){
        super(props);
        this.state={
        }
    }

    onChange=(date)=>{
        let {updateParent,name} = this.props;
        //this.setState({date:date},()=>{updateParent(name,date)});
        updateParent(name,date);
    }

    render(){
        let {minDate, disabled, selected,placeholderText, showYearDropdown, showMonthDropdown,maxDate, customInput, dateFormat, onFocus, onChangeRaw, dropdownMode, filterDate} = this.props,
            props = {};

        Object.assign(props,
            minDate && {minDate},
            disabled && {disabled},
            selected && {selected},
            showYearDropdown && {showYearDropdown},
            showMonthDropdown && {showMonthDropdown},
            placeholderText && {placeholderText},
            maxDate && {maxDate},
            dateFormat && {dateFormat},
            customInput && {customInput},
            onFocus && {onFocus},
            onChangeRaw && {onChangeRaw},
            dropdownMode && {dropdownMode},
            filterDate && {filterDate}
            );

        return(<div className='date-picker'>
            <DatePicker onChange={this.onChange}
                        {...props} popperModifiers={{
                            computeStyle: { gpuAcceleration: false }
                        }} />
            <span className="open-button"><i className='icon-calendar' /></span>
        </div>)
    }
}